// import 'video.js/dist/video-js.min.css';
import videojs from 'video.js';
// import 'videojs-vimeo-tech';
import './Vimeo.js';

class VideoStories {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    // this.debug = true;
    this.videojs = videojs;
    this.players = [];
    window.VideoStories = this;

  }

  init() {

    let _self = this;

    let videoBlocks = $('.o-section-stories-grid__video');
    let videoElements = videoBlocks.find('video');
    this.videoBlocks = videoBlocks;

    if(_self.debug) console.log('VideoStories videoBlocks', this.videoBlocks);

    if(this.videoBlocks.length > 0) {

      const videoJsOptions = {
        autoplay: false,
        normalizeAutoplay: true,
        loop: false,
        controls: false,
        responsive: true,
        fluid: true,
        paused: true,
        muted: false,
        aspectRatio: '1:1',
        vimeo: {
          pip: false,
          background: false,
          maxheight: 1234
        }
        // aspectRatio: '335:172', // 1.95:1
        // sources: [{
        //   src: '/path/to/video.mp4',
        //   type: 'video/mp4'
        // }]
      };

      // this.videoElements.each(function(i,videoElement){
      this.videoBlocks.each(function(i,videoBlock){

        if(_self.debug) console.log('VideoStories videoBlock', videoBlock);

        if ($(videoBlock).is(':visible') ) {

          let videoElement = $(videoBlock).find('video').get(0);
          if(_self.debug) console.log('VideoStories videoElement', videoElement);
          if(videoElement) {

            $(videoElement).attr('data-setup', $(videoElement).attr('data-setup-videojs'));
            //init videojs player
            var player = videojs(videoElement, videoJsOptions, () => {
              if(_self.debug) videojs.log('player is ready', this);
              // onReady && onReady(player);
            });
            // player.src({src: $(videoElement).attr('data-setup-src')});

            _self.players.push(player);

            player.on('ready', function(e){

              if(_self.debug) console.log('VideoStories player video ready', e, this, videoBlock, this.muted());
              $(videoBlock).addClass('is-ready');

            });

            player.on('play', function(e){


              if(_self.debug) console.log('VideoStories player video play', e, this, videoBlock, this.muted());

              $(videoBlock).addClass('has-started');
              $(videoBlock).addClass('is-playing');
              $(videoBlock).removeClass('is-paused');

            });
            player.on('pause', function(e){


              if(_self.debug) console.log('VideoStories player video pause', e, this, videoBlock, this.muted());

              $(videoBlock).addClass('is-paused');
              $(videoBlock).removeClass('is-playing');

            });

            player.on('ended', function(e){
              if(_self.debug) console.log('VideoStories ended event ', e, videoBlock);
              //rewind video
              player.tech_.setCurrentTime(0);
              $(videoBlock).removeClass('has-started').removeClass('is-playing');
            });

            if(_self.debug) console.log('VideoStories videoBlock btn-play', $(videoBlock).find('a.btn-play'));

            $(videoBlock).find('a.btn-play').on('click', function(e){

              if(_self.debug) console.log('VideoStories videoBlock btn-play click', this, e, player);
              this.blur();
              e.preventDefault();
              e.stopPropagation();
              //toggle play/pause
              if(player.paused()) {
                player.play();
              }
              else player.pause();

              
            });

          }



        } else {
          if(_self.debug) console.log('VideoStories videoBlock is not visible', videoBlock);
        }

      });

      // $(window).on('resize', _.debounce(this._resize.bind(this), 400));
      // this._resize();

    }

  }

  _resize() {

    let _self = this;

  }


}

export { VideoStories };
